export const MenuItemTypes = {
    ITEM: 'ITEM',
    MODIFIER: 'MODIFIER',
} as const;

export type MenuItemType = (typeof MenuItemTypes)[keyof typeof MenuItemTypes];
